/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { RefObject } from 'react'
import { Field, Form, Formik, FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Form as NXUIForm } from '@nexigendigital/nxui'
import { useCreateTwoFactorMutation } from 'api/account'
import { TwoFactorType } from 'models/authentication'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    form: RefObject<FormikProps<{ identifier: string }>>
    twoFactor: {
        validationSchema: object,
        type: TwoFactorType,
        field: object
    }
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function CreateTwoFactorVerificationCodeForm ({ form, twoFactor }: Props) {
    const [createTwoFactor] = useCreateTwoFactorMutation({ fixedCacheKey: `create-two-factor-${twoFactor.type}` })

    return (
        <Formik
            innerRef={form}
            enableReinitialize={true}
            initialValues={{
                identifier: ''
            }}
            validationSchema={twoFactor.validationSchema}
            onSubmit={({ identifier }) => {
                createTwoFactor({ identifier, type: twoFactor.type })
            }}
        >
            {({ isSubmitting }) => (
                <Form id={'createTwoFactorVerificationCodeForm'}>
                    <Field
                        name={'identifier'}
                        disabled={isSubmitting}
                        component={NXUIForm.InputField}
                        {...twoFactor.field}
                    />
                </Form>
            )}
        </Formik>
    )
}
